export const pt = {
  locationLine: "Levy Santiago, Bahia, Brasil",
};
